import { Expose } from 'class-transformer';
import { IsBoolean, IsEnum, IsNumber, IsOptional, IsString } from 'class-validator';

export enum ContractorType {
  Market = 'market',
  Reservation = 'reservation',
  Laundry = 'laundry',
  Cleaning = 'cleaning',
  Furniture = 'furniture',
  Shop = 'shop',
}

export enum ContractorStatus {
  /** Indicate that contractor dont accepted yet */
  Pending = 'Pending',
  /** Indicate that contractor accepted */
  Accepted = 'Accepted',
  /** Indicate that contractor disabled */
  Disabled = 'Disabled'
}

export class Contractor {
  @IsString()
  readonly id: string;

  @IsString()
  readonly label: string;

  @IsString()
  @Expose({ name: 'contact_email' })
  readonly contactEmail: string;

  @IsNumber()
  @IsOptional()
  @Expose({ name: 'application_fee' })
  readonly applicationFee?: number;

  @IsEnum(ContractorType)
  readonly type: ContractorType;

  @IsEnum(ContractorStatus)
  readonly status: ContractorStatus;

  constructor(init?: Contractor | Partial<Contractor>) {
    this.id = init?.id!;
    this.label = init?.label!;
    this.contactEmail = init?.contactEmail!;
    this.type = init?.type!;
    this.applicationFee = init?.applicationFee;
    this.status = init?.status!;
  }
}

export default Contractor;
